import React from 'react'

type IconProps = {
    className?: string
}

export const DownloadIcon: React.FC<IconProps> = ({ className }) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
<path d="M2.66675 11.3334V12.6667C2.66675 13.0204 2.80722 13.3595 3.05727 13.6096C3.30732 13.8596 3.64646 14.0001 4.00008 14.0001H12.0001C12.3537 14.0001 12.6928 13.8596 12.9429 13.6096C13.1929 13.3595 13.3334 13.0204 13.3334 12.6667V11.3334M11.3334 7.33341L8.00008 10.6667L4.66675 7.33341M8.00008 10.6667V2.66675" stroke="#26303B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

)
